class CartExpiryTimer extends HTMLElement {
  connectedCallback() {
    const key = 'rockyzCartExpiryDeadline';
    const durationMs = 60 * 60 * 1000;
    let deadline = parseInt(sessionStorage.getItem(key), 10);
    const now = Date.now();
    if (!deadline || deadline < now) {
      deadline = now + durationMs;
      sessionStorage.setItem(key, String(deadline));
    }

    const el = this.querySelector('[data-cart-expiry-countdown]');
    const tick = () => {
      if (Date.now() >= deadline) {
        deadline = Date.now() + durationMs;
        sessionStorage.setItem(key, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      if (el) {
        el.textContent = minutes + ':' + String(seconds).padStart(2, '0');
      }
    };
    tick();
    this._interval = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }
}

if (!customElements.get('cart-expiry-timer')) {
  customElements.define('cart-expiry-timer', CartExpiryTimer);
}
